module.exports = (__webpack_require__(36))(1208);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/react-redux/es/index.js from dll-reference vendor_23e55280757b464716ca
// module id = 691
// module chunks = 0